import React from 'react';
import LootBox from './LootBox';

export type ChestTier = 'bronze' | 'silver' | 'gold' | 'diamond';
export type ChestState = 'closed' | 'open';

interface ChestIconProps {
  tier: ChestTier;
  state?: ChestState;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export default function ChestIcon({ 
  tier, 
  state = 'closed', 
  className,
  size = 'md' 
}: ChestIconProps) {
  
  // Mapping the old xl size to lg for the new component
  const mappedSize = size === 'xl' ? 'lg' : size;

  return (
    <LootBox 
      tier={tier} 
      isOpen={state === 'open'} 
      size={mappedSize as any} 
      className={className} 
    />
  );
}
